<template>
  <v-row class="mx-0 w-100" v-resize="onResize">
    <v-data-table
      ref="bidsTable"
      :headers="bidsTableHeader"
      :items="bidsPrepared"
      class="elevation-0 mb-3 mx-3 w-100"
      :loading="!fetched"
      :disabled="!fetched"
      @update:options="setTableOptions"
      :server-items-length="itemsTotalCount"
      :options="tableOptions"
      :height="tableHeight"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:[lastHeaderElement]="props">
        {{ props.header.text }}
        <table-config-btn
          :table="tableName"
          :default-columns="defaultBidsTableHeader"
        />
      </template>
      <template v-slot:item.created_at="props">
        {{ props.item.created_at | moment("DD.MM.YYYY") }}
        <br/>
        {{ props.item.created_at | moment("HH:mm") }}
      </template>
      <template v-slot:item.phone="props">
        <span v-if="props.item.customer">
          {{ props.item.customer.phone }}
        </span>
        <span v-else>
          {{ props.item.customer_phone }}
        </span>
      </template>
      <template v-slot:item.customer_name="props">
        <span v-if="props.item.customer">
          <span
            class="dashed"
            @click="
              customerId = props.item.customer.id;
              customerEditForm = true;
            "
          >
            {{ props.item.customer.full_name }}
          </span>
        </span>
        <span v-else>
          {{ props.item.customer_name }}
        </span>
      </template>
      <template v-slot:item.desired_date="props">
        {{ props.item.desired_date | moment("DD.MM.YYYY") }}
        <br/>
        {{ props.item.desired_date | moment("HH:mm") }}
      </template>
      <template v-slot:item.comment="props">
        {{ props.item.comment }}
      </template>
      <template v-slot:item.operations="props">
        <div v-for="operation in props.item.operations">
          {{ getOperationName(operation, lang) }}
        </div>
      </template>
      <template v-slot:item.car="props">
        <span v-if="props.item.car">
          <span>
            {{ props.item.car.name }}
          </span>
          <beauty-car-number
            v-if="props.item.car && props.item.car.car_number"
            :number="props.item.car.car_number"
          ></beauty-car-number>
        </span>
        <span v-else>
          {{ props.item.brand }} {{ props.item.model }}
          <beauty-car-number
            v-if="props.item.car_number"
            :number="props.item.car_number"
          ></beauty-car-number>
        </span>
      </template>
      <template v-slot:item.vin="props">
        {{ props.item.car ? props.item.car.vin : props.item.vin}}
      </template>
      <template v-slot:item.url="props">
        <v-btn
            fab
            small
            text
            v-if="props.item.url"
            :href="props.item.url"
            :title="props.item.url"
            target="_blank"
            :disabled="!fetched"
        ><v-icon small>fa-link</v-icon></v-btn
        >
        <v-chip small v-for="utm in props.item.utm" class="ma-1">
          {{ utm.key }}: {{ utm.value }}
        </v-chip>
      </template>
      <template v-slot:item.stage="props">
        <bid-stage-select
            :bid-stages="bidStages"
            :stage="props.item.stage"
            :loading="
                nowProcessingBidWithId === props.item.id || !bidsStagesIsFetched
              "
            @update="
                (st) => {
                  props.item.stage = st;
                  props.item.bid_stage_id = st.id;
                  updateBid(props.item);
                }
              "
        ></bid-stage-select>
      </template>
      <template v-slot:item.actions="props">
        <div class="text-right" style="min-width: 280px">
          <span class="btn-td-wrap">
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  color="primary"
                  class="mb-0 ml-3 px-0 white--text"
                  :title="$t('common.edit')"
                  :disabled="!fetched"
                  @click="
                  activeBid = props.item;
                  bidWindow = true;
                "
              >
                <v-icon small>$pencil</v-icon>
              </v-btn>
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  class="mb-0 ml-3 px-0 white--text"
                  :color="!props.item.order ? 'success' : 'blue'"
                  :title="
                  !props.item.order
                    ? $t('common.creating_order')
                    : $t('common.go_to_order')
                "
                  :disabled="cartIsLoading || !fetched"
                  @click="handleClickOrderForBid(props.item)"
              >
                <v-icon small>$cart</v-icon>
              </v-btn>
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  class="mb-0 ml-3 px-0 white--text"
                  color="secondary"
                  :title="$t('common.maintenance_parts')"
                  :disabled="
                  (!props.item.maintenance_part_available && !(props.item.car && props.item.car.maintenance_part_available))||
                  cartIsLoading ||
                  !fetched
                "
                  @click="
                  showMaintenancePartsForm(props.item)
                "
              >
                <v-icon small>$oils</v-icon>
              </v-btn>

              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  class="mb-0 ml-3 px-0 white--text"
                  color="secondary"
                  title="OEM"
                  :disabled="
                  ((!props.item.levam_link ||
                  props.item.levam_link == -1 ) && (! props.item.car || props.item.car.levam_link==-1 || ! props.item.car.levam_link)) ||
                  cartIsLoading ||
                  !fetched
                  || props.item.car.levam_link.toString().length < 10
                "
                  @click="toOEMWidget(props.item.car || props.item)"
              >
                <v-icon small>$oem</v-icon>
              </v-btn>
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  @click="$store.dispatch('bids/remove', { id: props.item.id })"
                  color="red lighten-2"
                  class="mb-0 ml-3 px-0 white--text"
                  :disabled="cartIsLoading || !fetched"
                  :title="$t('common.remove')"
              >
                <v-icon small>$trash</v-icon>
              </v-btn>
            </span>
        </div>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    <v-dialog v-model="maintenancePartsForm" scrollable max-width="90%">
      <maintenanceParts></maintenanceParts>
    </v-dialog>
    <v-dialog v-model="customerEditForm" scrollable max-width="890">
      <customerForm
        @removed="customerEditForm=false"
        :is-visible="customerEditForm"
        @update="
          (data) => {
            this.customerEditForm = false;
            this.$store.dispatch('bids/getList');
          }
        "
        :customer-id="customerId"
      ></customerForm>
    </v-dialog>
    <v-dialog v-model="customerFindForm" scrollable max-width="500">
      <customerFindForm
        @select="
          (data) => {
            goToSearchWithCustomer(data);
          }
        "
        :visible="customerFindForm"
      ></customerFindForm>
    </v-dialog>
    <bid-window
      :show="bidWindow"
      :bid-id="activeBid && activeBid.id"
      :customer="activeBid && activeBid.customer"
      @hide="
        bidWindow = false;
        activeBid = null;
      "
      @update="
        (bid) => {
          activeBid = null;
        }
      "
    />
    <order-window
        :is-visible="orderWindow.isVisible"
        :order-id="orderWindow.orderId"
        @hide="orderWindow.orderId=null; orderWindow.isVisible=false;$store.dispatch('bids/getList')"
    />
  </v-row>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import CustomerFindForm from "@/components/customer/CustomerFindForm";
import BidsMixin from "@/mixins/bids";
import CustomerForm from "@/components/customer/CustomerForm.vue";
import MaintenanceParts from "@/components/garage/MaintenanceParts.vue";
import BeautyCarNumber from "@/components/common/BeautyCarNumber";
import CustomerGarage from "@/components/customer/CustomerGarage";
import CarForm from "@/components/garage/CarForm";
import BidStageSelect from "../../components/bid/BidStageSelect";
import BidWindow from "../../components/bid/BidWindow";
import TableConfigBtn from "@/components/common/TableConfigBtn";
import OrderWindow from "@/components/order/OrderWindow.vue";
export default {
  data: () => ({
    tableName: "bids",
    maintenancePartsForm: "",
    bidTab: 0,
    bidWindow: false,
    activeBid: null,
    customerFindForm: false,
    customerEditForm: false,
    customerId: null,
    tableHeight: "100",
    orderWindow: {
      orderId: null,
      isVisible: false
    }
  }),
  mixins: [CommonMixin, BidsMixin],
  components: {
    OrderWindow,
    TableConfigBtn,
    BidWindow,
    BidStageSelect,
    BeautyCarNumber,
    CustomerFindForm,
    CustomerForm,
    CustomerGarage,
    CarForm,
    MaintenanceParts,
  },
  mounted() {
    this.$store.dispatch("tables_config/get").then(() => {
      this.$store.dispatch("bid_stages/get");
    });
  },
  computed: {
    lastHeaderElement() {
      return (
        "header." +
        (this.bidsTableHeader.slice(-1) &&
          this.bidsTableHeader.slice(-1)[0] &&
          this.bidsTableHeader.slice(-1)[0].value)
      );
    },
    ...mapFields("site", ["lang"]),
    ...mapFields("bid_stages", ["bidStages"]),
    ...mapFields("bid_stages", { bidsStagesIsFetched: "fetched" }),
    ...mapFields("cart", ["cartIsLoading", "carts"]),
    ...mapFields("bids", [
      "nowProcessingBidWithId",
      "bids",
      "tableOptions",
      "search",
      "itemsTotalCount",
      "fetched",
    ]),
    bidsPrepared() {
      this.bids.forEach((bid) => {
        bid.utm = this.parseUTM(bid.url);
      });
      return this.bids;
    },
    bidsTableHeader() {
      let tableHeaderConfig = this.getConfiguredTableHeader(
        this.tableName,
        this.defaultBidsTableHeader
      );
      return tableHeaderConfig.filter((item) => item.is_hidden !== true);
    },
    defaultBidsTableHeader() {
      return [
        {
          text: this.$t("common.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.phone"),
          value: "phone",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.first_name"),
          value: "customer_name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewBids.desired_date"),
          value: "desired_date",
          sortable: true,
          class: "text-no-wrap",
        },
        { text: this.$t("common.comment"), value: "comment", sortable: false },
        {
          text: this.$t("common.repairtimes"),
          value: "operations",
          sortable: false,
        },
        {
          text: this.$t("common.car"),
          value: "car",
          sortable: false,
        },
        {
          text: this.$t("common.vin_frame"),
          value: "vin",
          sortable: false,
          class: " text-no-wrap",
        },
        {
          text: this.$t("viewBids.url"),
          value: "url",
          sortable: true,
          class: " text-no-wrap",
        },
        {
          text: this.$t("viewBids.bid_status"),
          sortable: false,
          class: "text-no-wrap",
          value: "stage",
        },
        {
          text: "",
          sortable: false,
          class: "text-no-wrap flex-nowrap justify-space-between",
          is_action_column: true,
          value: "actions",
        },
      ];
    },
  },
  methods: {
    showMaintenancePartsForm(item)
    {
      let data = {};
      if(item.car){
        data = {
          brand: item.car.brand,
          link: item.car.levam_link,
          car: item.car,
        }
      } else {
        data = {
          brand: item.brand,
          link: item.levam_link,
          car: item,
        }
      }
      this.$store.dispatch('garage/maintenanceParts', data);
      this.maintenancePartsForm = true;
    },
    updateBid(bid) {
      this.$store.dispatch("bids/update", bid).then((res) => {});
    },
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["bidsTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
    setTableOptions(options) {
      this.tableOptions = options;
      this.$store.dispatch("bids/getList");
    },
    parseUTM(url_string) {
      let result = [];
      if (!url_string) return result;
      if (url_string.includes("https://") || url_string.includes("http://")) {
        try {
          let url = new URL(url_string);
          let params = new URLSearchParams(url.search);
          params.forEach((value, key) => {
            if (key.includes("utm_")) {
              result.push({ key, value });
            }
          });
        } catch (e) {
          console.log("Parse bid url error:", e);
        }
      }
      return result;
    },
  },
  watch: {
    search(to) {
      if (to.length >= 3 || to.length === 0) {
        this.$store.dispatch("bids/getList");
      }
    },
    fetched() {
      this.$nextTick(() => {
        this.setTableHeight();
      });
    },
  },
};
</script>
<style>
.status-square {
  border-radius: 1px;
  width: 12px;
  height: 12px;
}
</style>
